import { SVGNAME_TO_DIMENSIONS_MAP_FIXED } from '@wre/infinity-svgs/_generatedSvgDimensFixed';
import type { SvgNameFixed } from '@wre/infinity-svgs';

/**
 * Web, we assume not using any clever static optimizations.
 *
 * File is a .svg and asset is a uri, so use our generated table.
 * - This is expensive to import because it's a big table!
 * - Another option would be to use Image.getSize, but that is asynchronous
 */
export default function getSvgDimensFixed(name: SvgNameFixed): { width: number; height: number } {
  return SVGNAME_TO_DIMENSIONS_MAP_FIXED[name];
}
